import React from 'react';
import './WhyYouShouldJoin.css';

const WhyYouShouldJoin = () => {
  return (
    <section className="mc-section mc-join-section">
      <div style={{ textAlign: 'center' }}>
        <h2 className="mc-section-title mc-gradient-accent">Why You Should Join</h2>
      </div>

      <div className="mc-join-grid">
        <div className="mc-join-card">
          <div className="mc-join-icon">👥</div>
          <h3 className="mc-join-title">Expert Mentorship</h3>
          <p className="mc-join-desc">Direct feedback from instructors who build AI products daily.</p>
        </div>
        <div className="mc-join-card">
          <div className="mc-join-icon">♾️</div>
          <h3 className="mc-join-title">Comprehensive Guidance </h3>
          <p className="mc-join-desc">Course materials, Notes, and quizzes and docs are yours forever.</p>
        </div>
        <div className="mc-join-card">
          <div className="mc-join-icon">🛠️</div>
          <h3 className="mc-join-title">85+ AI Tools</h3>
          <p className="mc-join-desc">Master the entire modern AI developer ecosystem.</p>
        </div>
        <div className="mc-join-card">
          <div className="mc-join-icon">🏆</div>
          <h3 className="mc-join-title">Offline Practice</h3>
          <p className="mc-join-desc">Spacial practice session after each lecture with instructors.</p>
        </div>

        <div className="mc-join-card">
          <div className="mc-join-icon">🚀</div>
          <h3 className="mc-join-title">Career Acceleration</h3>
          <p className="mc-join-desc">Skip years of trial and error with proven frameworks.</p>
        </div>

        <div className="mc-join-card">
          <div className="mc-join-icon">💼</div>
          <h3 className="mc-join-title">Portfolio Building</h3>
          <p className="mc-join-desc">Graduate with real apps deployed and ready to show employers.</p>
        </div>
        
        <div className="mc-join-card">
          <div className="mc-join-icon">📜</div>
          <h3 className="mc-join-title">Verified Certificate</h3>
          <p className="mc-join-desc">Showcase your verified credential on your LinkedIn profile.</p>
        </div>

         <div className="mc-join-card">
          <div className="mc-join-icon">🌐</div>
          <h3 className="mc-join-title">Peer Network</h3>
          <p className="mc-join-desc">Join an elite network of forward-thinking developers.</p>
        </div>
        
      </div>
    </section>
  );
};

export default WhyYouShouldJoin;
